import Checkbox from '@mui/material/Checkbox';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import { forwardRef, memo, ReactElement, Ref } from 'react';
import { useIntl } from 'react-intl';
import { CheckboxInputProps } from './types';

function CheckboxInput(
  props: CheckboxInputProps,
  ref: Ref<HTMLDivElement>
): ReactElement {
  const { labelId, handleChange, value } = props;
  const intl = useIntl();

  return (
    <FormControl ref={ref}>
      <FormControlLabel
        control={
          <Checkbox
            onChange={(_, isChecked) => handleChange(_, isChecked)}
            checked={!!value}
          />
        }
        label={formatTranslation(intl, unsafeTranslationKey(labelId) )}
      />
    </FormControl>
  );
}

export const MemoCheckboxInput = memo(forwardRef(CheckboxInput));
